import { useState, useEffect, useRef } from "react";

const R = "#D92B2B";
const RD = "#A01E1E";
const FIRE = "#FF5A1F";
const CREAM = "#FFF5E6";
const DARK = "#0F0A0A";
const DARKER = "#150C0C";

const menuItems = [
  { name: "CLASICĂ", sub: "Pui la grătar • legume proaspete • sos alb", price: "22", unit: "RON", tag: "BESTSELLER", emoji: "🌯" },
  { name: "XXL BEAST", sub: "Dublă carne • cartofi • sos picant • jalapeño", price: "35", unit: "RON", tag: "🔥 HOT", emoji: "💪" },
  { name: "BEEF SPECIAL", sub: "Vită marinată • ceapă caramelizată • sos negru", price: "30", unit: "RON", tag: null, emoji: "🥩" },
  { name: "VEGGIE", sub: "Falafel • hummus • legume la grătar • tahini", price: "20", unit: "RON", tag: "VEGAN", emoji: "🌿" },
  { name: "COMBO DUO", sub: "2 shaorme clasice + 2 sucuri la alegere", price: "48", unit: "RON", tag: "OFERTĂ", emoji: "🤝" },
  { name: "ÎN LIPIE", sub: "Rețeta casei • lipie caldă • sos roșu special", price: "25", unit: "RON", tag: null, emoji: "🫓" },
  { name: "CLASICĂ", sub: "Pui la grătar • legume proaspete • sos alb", price: "22", unit: "RON", tag: "BESTSELLER", emoji: "🌯" },
  { name: "XXL BEAST", sub: "Dublă carne • cartofi • sos picant • jalapeño", price: "35", unit: "RON", tag: "🔥 HOT", emoji: "💪" },
  { name: "BEEF SPECIAL", sub: "Vită marinată • ceapă caramelizată • sos negru", price: "30", unit: "RON", tag: null, emoji: "🥩" },
  { name: "VEGGIE", sub: "Falafel • hummus • legume la grătar • tahini", price: "20", unit: "RON", tag: "VEGAN", emoji: "🌿" },
  { name: "COMBO DUO", sub: "2 shaorme clasice + 2 sucuri la alegere", price: "48", unit: "RON", tag: "OFERTĂ", emoji: "🤝" },
  { name: "ÎN LIPIE", sub: "Rețeta casei • lipie caldă • sos roșu special", price: "25", unit: "RON", tag: null, emoji: "🫓" },
  { name: "CLASICĂ", sub: "Pui la grătar • legume proaspete • sos alb", price: "22", unit: "RON", tag: "BESTSELLER", emoji: "🌯" },
  { name: "XXL BEAST", sub: "Dublă carne • cartofi • sos picant • jalapeño", price: "35", unit: "RON", tag: "🔥 HOT", emoji: "💪" },
  { name: "BEEF SPECIAL", sub: "Vită marinată • ceapă caramelizată • sos negru", price: "30", unit: "RON", tag: null, emoji: "🥩" },
  { name: "VEGGIE", sub: "Falafel • hummus • legume la grătar • tahini", price: "20", unit: "RON", tag: "VEGAN", emoji: "🌿" },
  { name: "COMBO DUO", sub: "2 shaorme clasice + 2 sucuri la alegere", price: "48", unit: "RON", tag: "OFERTĂ", emoji: "🤝" },
  { name: "ÎN LIPIE", sub: "Rețeta casei • lipie caldă • sos roșu special", price: "25", unit: "RON", tag: null, emoji: "🫓" },
];

const offers = [
  { title: "MENIU PRÂNZ", time: "12:00 – 15:00", days: "Luni – Vineri", desc: "Shaormă + cartofi + suc", price: "28 RON", color: R },
  { title: "2 + 1 GRATUIT", time: "Toată ziua", days: "În fiecare joi", desc: "A treia shaormă e cadoul nostru", price: "PROMO", color: FIRE },
  { title: "COMBO FAMILIE", time: "Oricând", days: "7 zile din 7", desc: "4 shaorme + 4 sucuri + garnitură", price: "95 RON", color: RD },
];

function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

function FadeIn({ children, delay = 0, direction = "up", className = "" }) {
  const [ref, inView] = useInView();
  const transforms = { up: "translateY(40px)", left: "translateX(-40px)", right: "translateX(40px)", none: "none" };
  return (
    <div ref={ref} className={className} style={{
      opacity: inView ? 1 : 0,
      transform: inView ? "translate(0)" : transforms[direction],
      transition: `opacity 0.65s ease ${delay}s, transform 0.65s ease ${delay}s`
    }}>
      {children}
    </div>
  );
}

function Ticker() {
  const items = ["SHAORMA GURMANDULUI", "TIMIȘOARA", "PROASPĂT ZILNIC", "REȚETĂ AUTENTICĂ", "COMENZI RAPIDE", "STREET FOOD DE CALITATE"];
  const repeated = [...items, ...items, ...items];
  return (
    <div style={{ background: R, padding: "12px 0", overflow: "hidden", borderTop: `3px solid ${FIRE}`, borderBottom: `3px solid ${FIRE}` }}>
      <div style={{
        display: "flex", gap: "48px", whiteSpace: "nowrap",
        animation: "ticker 20s linear infinite",
      }}>
        {repeated.map((t, i) => (
          <span key={i} style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "18px", letterSpacing: "0.15em", color: CREAM, display: "flex", alignItems: "center", gap: "48px" }}>
            {t} <span style={{ color: FIRE, fontSize: "20px" }}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default function App() {
  const [heroVisible, setHeroVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("acasa");

  useEffect(() => { setTimeout(() => setHeroVisible(true), 80); }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["acasa", "oferte", "meniu", "despre", "contact"];
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) { setActiveSection(id); break; }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); };

  const navLinks = [
    { id: "acasa", label: "Acasă" }, { id: "oferte", label: "Oferte" },
    { id: "meniu", label: "Meniu" }, { id: "despre", label: "Despre" }, { id: "contact", label: "Contact" }
  ];

  return (
    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", background: DARK, color: CREAM, minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow+Condensed:wght@300;400;500;600;700;800&family=Barlow:wght@300;400;500&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: ${DARK}; }
        ::-webkit-scrollbar-thumb { background: ${R}; }
        @keyframes ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-33.33%); } }
        @keyframes flicker { 0%,100% { opacity:1; } 50% { opacity:0.85; } 92% { opacity:0.92; } }
        @keyframes pulse-ring { 0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(217,43,43,0.5); } 70% { transform: scale(1); box-shadow: 0 0 0 16px rgba(217,43,43,0); } 100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(217,43,43,0); } }
        @keyframes bob { 0%,100% { transform: translateY(0px) rotate(-2deg); } 50% { transform: translateY(-10px) rotate(-2deg); } }
        @keyframes fadeSlideUp { from { opacity:0; transform:translateY(60px); } to { opacity:1; transform:translateY(0); } }
        .nav-link { cursor: pointer; font-family: 'Bebas Neue', sans-serif; font-size: 16px; letter-spacing: 0.12em; color: rgba(255,245,230,0.55); transition: color 0.2s; }
        .nav-link:hover, .nav-link.active { color: ${CREAM}; }
        .nav-link.active { border-bottom: 2px solid ${R}; }
        .menu-card { background: ${DARKER}; border: 1px solid rgba(217,43,43,0.15); transition: all 0.25s; cursor: default; }
        .menu-card:hover { border-color: ${R}; transform: translateY(-3px); box-shadow: 0 12px 40px rgba(217,43,43,0.2); }
        .btn-fire { background: ${R}; color: ${CREAM}; border: none; padding: 16px 40px; font-family: 'Bebas Neue', sans-serif; font-size: 18px; letter-spacing: 0.15em; cursor: pointer; clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%); transition: background 0.2s, transform 0.15s; }
        .btn-fire:hover { background: ${FIRE}; transform: translateY(-2px); }
        .btn-ghost { background: transparent; color: ${CREAM}; border: 2px solid rgba(255,245,230,0.3); padding: 14px 38px; font-family: 'Bebas Neue', sans-serif; font-size: 18px; letter-spacing: 0.15em; cursor: pointer; clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%); transition: all 0.2s; }
        .btn-ghost:hover { border-color: ${CREAM}; background: rgba(255,245,230,0.05); }
        .diagonal-cut { clip-path: polygon(0 0, 100% 0, 100% 88%, 0 100%); }
        .tag-badge { display: inline-block; font-family: 'Bebas Neue', sans-serif; font-size: 12px; letter-spacing: 0.12em; padding: 3px 12px; background: ${R}; color: ${CREAM}; }
        .tag-fire { background: linear-gradient(90deg, ${R}, ${FIRE}); }
        .tag-green { background: #2a5c2a; }
        .tag-offer { background: #1a3a5c; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-btn { display: block !important; }
          .hero-flex { flex-direction: column !important; }
          .menu-grid { grid-template-columns: 1fr !important; }
          .offers-grid { grid-template-columns: 1fr !important; }
          .about-grid { grid-template-columns: 1fr !important; }
          .contact-grid { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: repeat(2,1fr) !important; }
          .hero-title-main { font-size: 72px !important; }
        }
      `}</style>

      {/* NAVBAR */}
      <nav style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 48px", background: `linear-gradient(to bottom, rgba(15,10,10,0.98), transparent)`, backdropFilter: "blur(8px)" }}>
        <div onClick={() => scrollTo("acasa")} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{ width: "38px", height: "38px", background: R, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", animation: "flicker 4s ease-in-out infinite", clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)" }}>🌯</div>
          <div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "22px", letterSpacing: "0.1em", lineHeight: 1 }}>Shaorma Gurmandului</div>
            <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.2em", color: R, textTransform: "uppercase", lineHeight: 1 }}>Timișoara</div>
          </div>
        </div>
        <div className="desktop-nav" style={{ display: "flex", gap: "28px", alignItems: "center" }}>
          {navLinks.map(l => <span key={l.id} className={`nav-link ${activeSection === l.id ? "active" : ""}`} onClick={() => scrollTo(l.id)}>{l.label}</span>)}
          <button className="btn-fire" style={{ padding: "10px 28px", fontSize: "14px" }} onClick={() => scrollTo("contact")}>Comandă Acum</button>
        </div>
        <button className="mobile-btn" style={{ display: "none", background: "none", border: "none", color: CREAM, fontSize: "28px", cursor: "pointer" }} onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        {menuOpen && (
          <div style={{ position: "fixed", inset: 0, background: DARKER, zIndex: 300, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "36px" }}>
            <button onClick={() => setMenuOpen(false)} style={{ position: "absolute", top: 24, right: 32, background: "none", border: "none", color: CREAM, fontSize: "36px", cursor: "pointer" }}>×</button>
            {navLinks.map(l => <span key={l.id} onClick={() => scrollTo(l.id)} style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "42px", letterSpacing: "0.1em", cursor: "pointer", color: CREAM }}>{l.label}</span>)}
          </div>
        )}
      </nav>

      {/* HERO */}
      <section id="acasa" style={{ minHeight: "100vh", background: `linear-gradient(135deg, ${DARKER} 0%, #1a0808 50%, #0f0a0a 100%)`, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        {/* BG fire glow */}
        <div style={{ position: "absolute", top: "20%", right: "10%", width: "600px", height: "600px", background: `radial-gradient(circle, rgba(217,43,43,0.12) 0%, transparent 65%)`, pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: 0, left: "30%", width: "400px", height: "400px", background: `radial-gradient(circle, rgba(255,90,31,0.06) 0%, transparent 65%)`, pointerEvents: "none" }} />

        {/* Big BG text */}
        <div style={{ position: "absolute", left: "-10px", top: "50%", transform: "translateY(-50%)", fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(140px, 22vw, 280px)", color: "rgba(217,43,43,0.06)", lineHeight: 0.9, userSelect: "none", letterSpacing: "-0.02em", pointerEvents: "none" }}>
          SHAORMA<br />GURMAN<br />DULUI
        </div>

        <div style={{ padding: "0 48px", zIndex: 2, paddingTop: "100px" }}>
          <div className="hero-flex" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "40px" }}>
            <div style={{ maxWidth: "680px", opacity: heroVisible ? 1 : 0, transform: heroVisible ? "translateY(0)" : "translateY(50px)", transition: "all 1s ease" }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", background: "rgba(217,43,43,0.15)", border: `1px solid rgba(217,43,43,0.4)`, padding: "6px 16px", marginBottom: "28px" }}>
                <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: R, animation: "pulse-ring 2s infinite" }} />
                <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "12px", letterSpacing: "0.2em", color: R, fontWeight: 600, textTransform: "uppercase" }}>Deschis Acum • 10:00 – 23:00</span>
              </div>

              <h1 className="hero-title-main" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(64px, 11vw, 130px)", lineHeight: 0.92, letterSpacing: "0.01em", marginBottom: "28px" }}>
                <span style={{ display: "block", color: CREAM }}>CEL MAI BUN</span>
                <span style={{ display: "block", color: R, textShadow: `0 0 60px rgba(217,43,43,0.4)` }}>STREET FOOD</span>
                <span style={{ display: "block", color: CREAM }}>DIN ORAȘ</span>
              </h1>

              <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "17px", fontWeight: 300, lineHeight: 1.8, color: "rgba(255,245,230,0.6)", marginBottom: "40px", maxWidth: "480px" }}>
                Rețete autentice, carne proaspătă zilnic și sosuri pregătite în casă. Gurmandului — nu doar o shaormă, o experiență.
              </p>

              <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
                <button className="btn-fire" onClick={() => scrollTo("meniu")}>🌯 Vezi Meniul</button>
                <button className="btn-ghost" onClick={() => scrollTo("oferte")}>Oferte Speciale</button>
              </div>

              <div style={{ display: "flex", gap: "40px", marginTop: "56px", paddingTop: "40px", borderTop: "1px solid rgba(217,43,43,0.2)" }}>
                {[["5+", "Ani de\nexperiență"], ["1000+", "Clienți\nfericiți"], ["100%", "Ingrediente\nproaspete"]].map(([n, l], i) => (
                  <div key={i}>
                    <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "42px", color: R, lineHeight: 1 }}>{n}</div>
                    <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "12px", color: "rgba(255,245,230,0.4)", whiteSpace: "pre-line", lineHeight: 1.4, marginTop: "4px" }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Hero visual */}
            <div style={{ flexShrink: 0, animation: "bob 4s ease-in-out infinite", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ fontSize: "clamp(100px, 14vw, 180px)", filter: "drop-shadow(0 0 40px rgba(217,43,43,0.4))", userSelect: "none" }}><img src="https://www.shaormitza.ro/wp-content/uploads/2026/02/ChatGPT-Image-11-feb.-2026-13_08_09-683x1024.png" alt="Hero Image" width="180" height="180" /></div>
              <div style={{ background: R, padding: "10px 24px", fontFamily: "'Bebas Neue', sans-serif", fontSize: "16px", letterSpacing: "0.2em", marginTop: "16px", clipPath: "polygon(0 0, calc(100% - 8px) 0, 100% 100%, 8px 100%)" }}>
                DE LA 22 RON
              </div>
            </div>
          </div>
        </div>

        {/* Bottom diagonal */}
        <div style={{ position: "absolute", bottom: -2, left: 0, right: 0, height: "80px", background: DARK, clipPath: "polygon(0 100%, 100% 0%, 100% 100%)" }} />
      </section>

      {/* TICKER */}
      <Ticker />

      {/* OFERTE */}
      <section id="oferte" style={{ padding: "100px 48px", background: DARK, position: "relative" }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "baseline", gap: "16px", marginBottom: "56px" }}>
            <div style={{ width: "40px", height: "3px", background: R }} />
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "12px", letterSpacing: "0.25em", color: R, textTransform: "uppercase", fontWeight: 600 }}>Promoții active</span>
          </div>
          <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(48px, 7vw, 80px)", letterSpacing: "0.02em", marginBottom: "48px", lineHeight: 0.95 }}>
            OFERTE<br /><span style={{ color: R }}>SPECIALE</span>
          </h2>
        </FadeIn>
        <div className="offers-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "3px" }}>
          {offers.map((o, i) => (
            <FadeIn key={i} delay={i * 0.12}>
              <div style={{ background: DARKER, borderTop: `4px solid ${o.color}`, padding: "44px 36px", position: "relative", overflow: "hidden", transition: "transform 0.25s", cursor: "default" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}>
                <div style={{ position: "absolute", top: 0, right: 0, width: "120px", height: "120px", background: `radial-gradient(circle at top right, rgba(${o.color === FIRE ? "255,90,31" : "217,43,43"},0.08), transparent)`, pointerEvents: "none" }} />
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "13px", letterSpacing: "0.2em", color: o.color, marginBottom: "16px" }}>{o.days} • {o.time}</div>
                <h3 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "32px", letterSpacing: "0.05em", marginBottom: "12px", lineHeight: 1 }}>{o.title}</h3>
                <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "14px", fontWeight: 300, color: "rgba(255,245,230,0.5)", lineHeight: 1.7, marginBottom: "28px" }}>{o.desc}</p>
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "44px", color: o.color, lineHeight: 1 }}>{o.price}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* MENIU */}
      <section id="meniu" style={{ padding: "100px 48px", background: DARKER }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "baseline", gap: "16px", marginBottom: "56px" }}>
            <div style={{ width: "40px", height: "3px", background: R }} />
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "12px", letterSpacing: "0.25em", color: R, textTransform: "uppercase", fontWeight: 600 }}>Ce servim</span>
          </div>
          <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(48px, 7vw, 80px)", letterSpacing: "0.02em", marginBottom: "48px", lineHeight: 0.95 }}>
            MENIUL<br /><span style={{ color: R }}>NOSTRU</span>
          </h2>
        </FadeIn>
        <div className="menu-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "3px" }}>
          {menuItems.map((item, i) => (
            <FadeIn key={i} delay={i * 0.07}>
              <div className="menu-card" style={{ padding: "32px 36px", display: "flex", alignItems: "center", gap: "24px" }}>
                <div style={{ fontSize: "44px", flexShrink: 0, filter: "drop-shadow(0 2px 8px rgba(217,43,43,0.3))" }}>{item.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px", flexWrap: "wrap" }}>
                    <h3 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "24px", letterSpacing: "0.05em" }}>{item.name}</h3>
                    {item.tag && (
                      <span className={`tag-badge ${item.tag.includes("🔥") ? "tag-fire" : item.tag === "VEGAN" ? "tag-green" : item.tag === "OFERTĂ" ? "tag-offer" : ""}`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "13px", fontWeight: 300, color: "rgba(255,245,230,0.4)", lineHeight: 1.6 }}>{item.sub}</p>
                </div>
                <div style={{ flexShrink: 0, textAlign: "right" }}>
                  <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "36px", color: R, lineHeight: 1 }}>{item.price}</div>
                  <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "11px", color: "rgba(255,245,230,0.3)", letterSpacing: "0.1em" }}>{item.unit}</div>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={0.3}>
          <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "12px", color: "rgba(255,245,230,0.2)", marginTop: "20px", textAlign: "center", letterSpacing: "0.05em" }}>
            * Prețurile includ TVA. Meniul se poate modifica sezonier.
          </p>
        </FadeIn>
      </section>

      {/* DESPRE */}
      <section id="despre" style={{ padding: "100px 48px", background: DARK, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", right: "-100px", top: "50%", transform: "translateY(-50%)", fontSize: "300px", opacity: 0.03, fontFamily: "'Bebas Neue', sans-serif", userSelect: "none", color: R, pointerEvents: "none" }}>G</div>
        <div className="about-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "80px", alignItems: "center", position: "relative", zIndex: 1 }}>
          <FadeIn direction="left">
            <div style={{ display: "flex", alignItems: "baseline", gap: "16px", marginBottom: "32px" }}>
              <div style={{ width: "40px", height: "3px", background: R }} />
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "12px", letterSpacing: "0.25em", color: R, textTransform: "uppercase", fontWeight: 600 }}>Povestea noastră</span>
            </div>
            <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(44px, 6vw, 72px)", lineHeight: 0.95, marginBottom: "32px" }}>
              PASIUNE<br /><span style={{ color: R }}>SERVITĂ</span><br />ZILNIC
            </h2>
            <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "16px", fontWeight: 300, lineHeight: 1.9, color: "rgba(255,245,230,0.55)", marginBottom: "20px" }}>
              Shaorma Gurmandului s-a născut dintr-o pasiune reală pentru mâncare de stradă autentică. Nu folosim scurtături — fiecare ingredient este ales cu grijă, carnea vine proaspătă în fiecare dimineață.
            </p>
            <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "16px", fontWeight: 300, lineHeight: 1.9, color: "rgba(255,245,230,0.55)", marginBottom: "40px" }}>
              Sosurile noastre sunt preparate după rețete proprii. Lipia e caldă. Gustul e real.
            </p>
            <button className="btn-fire" onClick={() => scrollTo("contact")}>📞 Contactează-ne</button>
          </FadeIn>
          <FadeIn direction="right" delay={0.15}>
            <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "3px" }}>
              {[
                { num: "5+", label: "Ani pe piață", icon: "🏆" },
                { num: "1K+", label: "Clienți fideli", icon: "❤️" },
                { num: "12+", label: "Produse în meniu", icon: "🌯" },
                { num: "100%", label: "Proaspăt zilnic", icon: "✅" },
              ].map((s, i) => (
                <div key={i} style={{ background: DARKER, padding: "36px 28px", borderBottom: `3px solid ${i % 2 === 0 ? R : FIRE}`, textAlign: "center" }}>
                  <div style={{ fontSize: "28px", marginBottom: "8px" }}>{s.icon}</div>
                  <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "48px", color: i % 2 === 0 ? R : FIRE, lineHeight: 1 }}>{s.num}</div>
                  <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "12px", color: "rgba(255,245,230,0.35)", marginTop: "6px", letterSpacing: "0.05em" }}>{s.label}</div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" style={{ padding: "100px 48px", background: DARKER }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "baseline", gap: "16px", marginBottom: "56px" }}>
            <div style={{ width: "40px", height: "3px", background: R }} />
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "12px", letterSpacing: "0.25em", color: R, textTransform: "uppercase", fontWeight: 600 }}>Găsește-ne</span>
          </div>
          <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(48px, 7vw, 80px)", letterSpacing: "0.02em", marginBottom: "56px", lineHeight: 0.95 }}>
            CONTACT &<br /><span style={{ color: R }}>PROGRAM</span>
          </h2>
        </FadeIn>
        <div className="contact-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "3px" }}>
          {[
            { icon: "📍", label: "ADRESĂ", main: "Strada Gurmandului, Nr. 1", sub: "Timișoara, România" },
            { icon: "🕐", label: "PROGRAM", main: "Lun–Vin: 10:00–23:00", sub: "Sâm–Dum: 11:00–24:00" },
            { icon: "📞", label: "TELEFON", main: "0700 000 000", sub: "Comenzi & Info" },
            { icon: "📩", label: "EMAIL", main: "contact@shaormagurm.ro", sub: "Răspundem în max 24h" },
          ].map((c, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div style={{ background: DARK, padding: "44px 40px", borderLeft: `4px solid ${i % 2 === 0 ? R : FIRE}`, transition: "transform 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateX(4px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "translateX(0)"}>
                <div style={{ fontSize: "28px", marginBottom: "16px" }}>{c.icon}</div>
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "12px", letterSpacing: "0.25em", color: i % 2 === 0 ? R : FIRE, marginBottom: "10px" }}>{c.label}</div>
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "24px", letterSpacing: "0.04em", marginBottom: "6px" }}>{c.main}</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "13px", color: "rgba(255,245,230,0.35)", fontWeight: 300 }}>{c.sub}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background: "#080404", padding: "40px 48px", borderTop: `3px solid ${R}` }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
          <div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "22px", letterSpacing: "0.08em" }}>Shaorma Gurmandului</div>
            <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: "11px", color: "rgba(255,245,230,0.25)", marginTop: "4px", letterSpacing: "0.1em" }}>© 2025 — Timișoara, România</div>
          </div>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#22c55e", animation: "pulse-ring 2s infinite" }} />
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "13px", color: "#22c55e", letterSpacing: "0.1em", fontWeight: 600 }}>DESCHIS ACUM</span>
          </div>
        </div>
      </footer>
    </div>
  );
}